import { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import { flashbackReplayState, seekFlashbackReplay, teleportToReplayPlayer } from '../flashback/flashbackReplay'
import styles from './flashbackReplayControls.module.css'

const time = (ticks: number) => {
  const seconds = Math.max(0, Math.floor(ticks / 20))
  return `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`
}

export default function FlashbackReplayControls () {
  const state = useSnapshot(flashbackReplayState)
  const [seekTick, setSeekTick] = useState(0)

  useEffect(() => setSeekTick(state.currentTick), [state.currentTick])
  useEffect(() => {
    if (!state.active) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.code !== 'KeyP' || ['input', 'textarea', 'select'].includes((event.target as HTMLElement)?.tagName?.toLowerCase())) return
      event.preventDefault()
      flashbackReplayState.playerMenuOpen = !flashbackReplayState.playerMenuOpen
    }
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [state.active])

  const players = [...state.players]
    .filter(player => player.entityId !== undefined)
    .sort((a, b) => a.username.localeCompare(b.username))

  if (!state.active) return null

  return <>
    <section className={styles.timeline} aria-label='Contrôles du replay Flashback'>
      <button disabled={!state.ready} onClick={() => { flashbackReplayState.isPlaying = !flashbackReplayState.isPlaying }}>
        {state.isPlaying ? '❚❚' : '▶'}
      </button>
      <span>{time(state.currentTick)}</span>
      <input
        aria-label='Timeline de la partie'
        type='range'
        min={0}
        max={Math.max(1, state.totalTicks)}
        value={seekTick}
        onChange={event => setSeekTick(Number(event.target.value))}
        onPointerUp={() => seekFlashbackReplay(seekTick)}
        onKeyUp={event => { if (event.key === 'Enter') seekFlashbackReplay(seekTick) }}
      />
      <span>{time(state.totalTicks)}</span>
      <button className={styles.speed} onClick={() => { flashbackReplayState.speed = state.speed >= 4 ? 0.5 : state.speed * 2 }}>×{state.speed}</button>
      <button className={styles.players} onClick={() => { flashbackReplayState.playerMenuOpen = !flashbackReplayState.playerMenuOpen }}>P Joueurs</button>
      {!state.ready && <em>Préparation du monde…</em>}
    </section>
    {state.playerMenuOpen && <section className={styles.playerMenu}>
      <header><div><small>TÉLÉPORTATION SPECTATEUR</small><strong>Joueurs du replay</strong></div><button onClick={() => { flashbackReplayState.playerMenuOpen = false }}>×</button></header>
      {players.map(player => <button key={player.uuid} onClick={() => teleportToReplayPlayer(player.entityId!)}><span>{player.username}</span><small>Téléporter</small></button>)}
      {!players.length && <p>Les joueurs apparaîtront après le chargement du snapshot.</p>}
    </section>}
  </>
}
